export const GET_SURVEYS_REQUEST = 'GET_SURVEYS_REQUEST';
export const GET_SURVEYS_SUCCESS = 'GET_SURVEYS_SUCCESS';
export const GET_SURVEYS_FAILURE = 'GET_SURVEYS_FAILURE';

export const GET_SURVEY_CHARTS_REQUEST = 'GET_SURVEY_CHARTS_REQUEST';
export const GET_SURVEY_CHARTS_SUCCESS = 'GET_SURVEY_CHARTS_SUCCESS';
export const GET_SURVEY_CHARTS_FAILURE = 'GET_SURVEY_CHARTS_FAILURE';
export const CLEAR_SURVEY_CHARTS = 'CLEAR_SURVEY_CHARTS';

export const GET_PERIODS_REQUEST = 'GET_PERIODS_REQUEST';
export const GET_PERIODS_SUCCESS = 'GET_PERIODS_SUCCESS';
export const GET_PERIODS_FAILURE = 'GET_PERIODS_FAILURE';

export const GET_SPOT_CHARTS_REQUEST = 'GET_SPOT_CHARTS_REQUEST';
export const GET_SPOT_CHARTS_SUCCESS = 'GET_SPOT_CHARTS_SUCCESS';
export const GET_SPOT_CHARTS_FAILURE = 'GET_SPOT_CHARTS_FAILURE';
export const CLEAR_SPOT_CHARTS = 'CLEAR_SPOT_CHARTS';

export const CREATE_SPOT_REQUEST = 'CREATE_SPOT_REQUEST';
export const CREATE_SPOT_SUCCESS = 'CREATE_SPOT_SUCCESS';
export const CREATE_SPOT_FAILURE = 'CREATE_SPOT_FAILURE';

export const GET_SURVEY_DEMOGRAPHICS_REQUEST = 'GET_SURVEY_DEMOGRAPHICS_REQUEST';
export const GET_SURVEY_DEMOGRAPHICS_SUCCESS = 'GET_SURVEY_DEMOGRAPHICS_SUCCESS';
export const GET_SURVEY_DEMOGRAPHICS_FAILURE = 'GET_SURVEY_DEMOGRAPHICS_FAILURE';

export const GET_SURVEY_RESPONDENTS_REQUEST = 'GET_SURVEY_RESPONDENTS_REQUEST';
export const GET_SURVEY_RESPONDENTS_SUCCESS = 'GET_SURVEY_RESPONDENTS_SUCCESS';
export const GET_SURVEY_RESPONDENTS_FAILURE = 'GET_SURVEY_RESPONDENTS_FAILURE';
export const CLEAR_SURVEY_RESPONDENTS = 'CLEAR_SURVEY_RESPONDENTS';

export const GET_SURVEY_ANSWER_GROUPS_REQUEST = 'GET_SURVEY_ANSWER_GROUPS_REQUEST';
export const GET_SURVEY_ANSWER_GROUPS_SUCCESS = 'GET_SURVEY_ANSWER_GROUPS_SUCCESS';
export const GET_SURVEY_ANSWER_GROUPS_FAILURE = 'GET_SURVEY_ANSWER_GROUPS_FAILURE';

export const DOWNLOAD_SURVEY_RESPONSES_REQUEST = 'DOWNLOAD_SURVEY_RESPONSES_REQUEST';
export const DOWNLOAD_SURVEY_RESPONSES_SUCCESS = 'DOWNLOAD_SURVEY_RESPONSES_SUCCESS';
export const DOWNLOAD_SURVEY_RESPONSES_FAILURE = 'DOWNLOAD_SURVEY_RESPONSES_FAILURE';



// WEBPACK FOOTER //
// ./src/store/modules/survey/mutation-types.js